<template>
  <section>
    <v-card :loading="isFindApiKeysPending">
      <v-card-title>
        <span class="text-h4">
          API
          <span class="pl-3 subtitle-1">Settings</span>
        </span>
      </v-card-title>
      <v-card-subtitle class="pl-5 body-1"
        >You can access your bot's data via its API.</v-card-subtitle
      >
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                label="API Endpoint"
                hint="This is the base URL of your bot's API"
                v-model="bot.app_url"
                prepend-icon="mdi-api"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-alert border="left" color="error" v-if="webhookUrlError">{{
                webhookUrlError
              }}</v-alert>
              <v-text-field
                label="API Token"
                hint="Your API token"
                v-model="myApiKey.api_key"
                prepend-icon="mdi-shield-key"
                readonly
              ></v-text-field>
              <div class="mt-4 d-flex justify-end">
                <v-btn
                  color="primary"
                  outlined
                  @click="generateApiToken()"
                  v-if="!myApiKey.api_key"
                  >Generate</v-btn
                >
                <v-btn
                  color="error"
                  outlined
                  @click="revokeApiToken()"
                  v-if="myApiKey.api_key"
                  >Revoke</v-btn
                >
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions></v-card-actions>
    </v-card>
  </section>
</template>

<script>
import { models } from "feathers-vuex";
import { mapActions, mapGetters } from "vuex";
import { makeFindMixin } from "feathers-vuex";

export default {
  data: () => ({
    loading: false,
    isWebhookValid: false,
    webhookUrlError: null,
  }),
  mixins: [
    makeFindMixin({ service: "api-keys" }),
  ],
  created() {},
  mounted() {},
  computed: {
    ...mapGetters("apiAuth", ["user"]),
    apiKeysParams() {
      return {
        query: {
          user_id: this.user.id
        },
      };
    },
    myApiKey: {
      get() {
        return (this.apiKeys && this.apiKeys.length && this.apiKeys[0]) || {};
      },
      set(token) {
        return token;
      },
    }
  },
  methods: {
    ...mapActions("app", ["showMessage"]),
    async generateApiToken() {
      const { ApiKeys } = models.bot;
      let myApiKey = new ApiKeys({
        user_id: this.user.id
      });

      this.myApiKey = await myApiKey.create();
    },
    async revokeApiToken() {
      this.myApiKey.remove();
    },
  },
  props: {
    bot: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
};
</script>

<style lang="scss" scoped>
</style>